import { getWebApiUrl, httpClient } from "@utils";
import { SSOGamesUserData } from "@api-types/user/SSOGamesUserData";
import { SSOGamesResponse } from "@api-types/user/SSOGamesResponse";
import { ApiRequestContextData, ContextOptions } from "@utils/api-config/types";
import { getMvcRequestHeaders } from "@utils/api-config/getMvcRequestHeaders";
import { getApiRequestContext } from "@utils/api-config";

export default class GamesApiService {
	private static get baseUrl(): string {
		return `${getWebApiUrl()}/api/games`;
	}

	static getRequestHeaders = (
		context: ApiRequestContextData | null
	): HeadersInit => {
		const appHeaders = getMvcRequestHeaders(context);
		appHeaders["Content-Type" as keyof HeadersInit] = "application/json";
		return appHeaders;
	};
	static getRedirectUrl(
		ssoGamesUserData: SSOGamesUserData,
		options?: ContextOptions
	): Promise<SSOGamesResponse> {
		const context = getApiRequestContext(options);
		const url = `${this.baseUrl}/url`;
		const headers = this.getRequestHeaders(context);

		return httpClient.post(url, JSON.stringify(ssoGamesUserData), headers);
	}
}
